import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f9c3bbe4")

_pushScopeId("data-v-f9c3bbe4")
const _hoisted_1 = {
  key: 0,
  class: "ui__entrust_main"
}
const _hoisted_2 = { class: "ui__entrust_body" }
const _hoisted_3 = { class: "entrust-main" }
const _hoisted_4 = { class: "entrust-img" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")

  return (_ctx.state.entrustList)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_componentTitle, { title: "委托检测项" }),
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.entrustList, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "entrust-main-item",
                key: item.code,
                onClick: ($event: any) => (_ctx.clickTab(item.code))
              }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("img", {
                    src: item.iconUrl,
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("p", null, _toDisplayString(item.name), 1)
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})